import React from 'react'
import { useState } from 'react';
import axios from 'axios';
const PostJob = () => {

    const [questions, setQuestions] = useState([]);
    const [newQuestion, setNewQuestion] = useState({ text: "", type: "text" });
    const [allowSharing, setAllowSharing] = useState(false); // Toggle for sharing


    const handleSubmit = async () => {
        console.log({
            title,
            description,
            category,
            locationType,
            location,
            experienceLevel,
            salaryRange,
            deadline,
            department,
            responsibilities,
            requirements,
            applicationLink,
            contactEmail,
            allowSharing,
            questions
        });

        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', description);
        formData.append('category', category);
        formData.append('locationType', locationType);
        formData.append('location', location);
        formData.append('experienceLevel', experienceLevel);
        formData.append('salaryRange', salaryRange);
        formData.append('deadline', deadline);
        formData.append('department', department);
        formData.append('responsibilities', responsibilities);
        formData.append('requirements', requirements);
        formData.append('applicationLink', applicationLink);
        formData.append('contactEmail', contactEmail);
        formData.append('allowSharing', String(allowSharing));
        formData.append('questions', JSON.stringify(questions));
        if (file) {
            formData.append('image', file); // Append the logo
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/postjob`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data' // Important for file uploads
                }
            });

            console.log('Job posted successfully:', response.data);
            alert('Job posted successfully!');
            resetForm();
            // Optionally, reset the form or show a success message
        } catch (error) {
            console.error('Error posting job:', error);
            // Optionally, show an error message
        }


    };

    const resetForm = () => {
        setTitle('');
        setDescription('');
        setCategory('');
        setLocationType('');
        setLocation('');
        setExperienceLevel('');
        setSalaryRange('');
        setDeadline('');
        setDepartment('');
        setResponsibilities('');
        setRequirements('');
        setApplicationLink('');
        setContactEmail('');
        setAllowSharing(false);
        setQuestions([]);
        setFile(null)
    };

    const getRandomValue = (array) => array[Math.floor(Math.random() * array.length)];

    const handlePrefill = () => {
        const jobTitles = [
            'Software Engineer',
            'Marketing Specialist',
            'Data Analyst',
            'Product Manager',
            'Graphic Designer'
        ];
        const descriptions = [
            'Responsible for building and maintaining web applications.',
            'Create and execute marketing strategies for product campaigns.',
            'Analyze data to provide business insights.',
            'Manage product lifecycle from ideation to launch.',
            'Design creative assets for digital and print media.'
        ];
        const categories = ['Full-Time', 'Part-Time', 'Contract', 'Freelance', 'Internship'];
        const locationTypes = ['Remote', 'Hybrid', 'In-office'];
        const locations = ['New York', 'San Francisco', 'London', 'Sydney', 'Remote'];
        const experienceLevels = ['Entry Level', 'Mid Level', 'Senior Level'];
        const salaryRanges = ['<3 LPA', '3-5 LPA', '5-10 LPA', '10-20 LPA', '>20 LPA'];
        const deadlines = ['2024-12-31', '2025-01-31', '2025-02-28'];
        const departments = ['Engineering', 'Marketing', 'Sales', 'HR', 'Finance', 'Design'];
        const responsibilitiesList = [
            'Collaborate with team members to deliver quality work.',
            'Plan and execute marketing campaigns.',
            'Develop scalable backend systems.',
            'Create visually appealing designs.',
            'Prepare reports on project progress.'
        ];
        const requirementsList = [
            'Bachelor’s degree in relevant field.',
            'Strong analytical skills.',
            'Proficiency in JavaScript and React.',
            'Excellent communication skills.',
            'Experience with Adobe Creative Suite.'
        ];
        const applicationLinks = [
            'https://company.com/apply',
            'https://jobs.com/apply',
            'https://careers.com/apply'
        ];
        const contactEmails = ['hr@company.com', 'jobs@company.com', 'apply@careers.com'];

        setTitle(getRandomValue(jobTitles));
        setDescription(getRandomValue(descriptions));
        setCategory(getRandomValue(categories));
        setLocationType(getRandomValue(locationTypes));
        setLocation(getRandomValue(locations));
        setExperienceLevel(getRandomValue(experienceLevels));
        setSalaryRange(getRandomValue(salaryRanges));
        setDeadline(getRandomValue(deadlines));
        setDepartment(getRandomValue(departments));
        setResponsibilities(getRandomValue(responsibilitiesList));
        setRequirements(getRandomValue(requirementsList));
        setApplicationLink(getRandomValue(applicationLinks));
        setContactEmail(getRandomValue(contactEmails));
        setAllowSharing(Math.random() > 0.5); // Randomize true/false
        setQuestions([
            {
                id: 1,
                type: 'short-answer',
                question: 'What is your name?',
                options: [],
                required: Math.random() > 0.5,
            },
            {
                id: 2,
                type: 'long-answer',
                question: 'Describe your experience.',
                options: [],
                required: Math.random() > 0.5,
            },
            {
                id: 3,
                type: 'dropdown',
                question: 'Select your preferred location:',
                options: ['Remote', 'Hybrid', 'In-office'],
                required: Math.random() > 0.5,
            },
            {
                id: 4,
                type: 'mcq',
                question: 'Which programming languages are you proficient in?',
                options: ['JavaScript', 'Python', 'Java', 'C++'],
                required: Math.random() > 0.5,
            },
        ]);
    };

    const [showLocationInput, setShowLocationInput] = useState(false);

    const handleLocationChange = (e) => {
        setLocation(e.target.value);
    };

    const [preview, setPreview] = useState(false);

    // Add a new question
    const addQuestion = () => {
        setQuestions([
            ...questions,
            { id: questions.length + 1, type: "short-answer", question: "", options: [], required: false },
        ]);
    };
    // Update a question's property
    const updateQuestion = (id, field, value) => {
        setQuestions((prev) =>
            prev.map((q) => (q.id === id ? { ...q, [field]: value } : q))
        );
    };

    // Delete a question
    const deleteQuestion = (id) => {
        setQuestions((prev) => prev.filter((q) => q.id !== id));
    };

    // Render options input for dropdown or MCQ
    const renderOptionsInput = (id) => (
        <div className="mt-2">
            <label className="block text-sm font-medium text-gray-600 mb-1">Options</label>
            <input
                type="text"
                placeholder="Comma-separated options (e.g., Option 1, Option 2)"
                className="w-full p-2 border border-gray-300 rounded-lg"
                onChange={(e) =>
                    updateQuestion(id, "options", e.target.value.split(",").map((opt) => opt.trim()))
                }
            />
        </div>
    );

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('Full-Time');
    const [locationType, setLocationType] = useState('In Office');
    const [location, setLocation] = useState('');
    const [experienceLevel, setExperienceLevel] = useState('Entry Level');
    const [salaryRange, setSalaryRange] = useState('<3 LPA');
    const [deadline, setDeadline] = useState('');
    const [department, setDepartment] = useState('Engineering');
    const [responsibilities, setResponsibilities] = useState('');
    const [requirements, setRequirements] = useState('');
    const [applicationLink, setApplicationLink] = useState('');
    const [contactEmail, setContactEmail] = useState('');
    const [file, setFile] = useState(null);
    //   const [allowSharing, setAllowSharing] = useState(false);
    //   const [showLocationInput, setShowLocationInput] = useState(true); // Default to true for 'In Office'

    const handleToggleSharing = () => {
        setAllowSharing(!allowSharing);
    };

    const handleLocationTypeChange = (e) => {
        const selectedLocationType = e.target.value;
        setLocationType(selectedLocationType);
        setShowLocationInput(selectedLocationType === 'In Office');
    };
    // Form Preview Component
    const FormPreview = ({ questions }) => {
        return (
            <div className="w-full max-w-3xl mx-auto p-6 bg-white shadow-xl rounded-lg mt-6">
                <h2 className="text-2xl font-semibold text-center text-gray-700 mb-4">
                    Form Preview
                </h2>
                {questions.map((q, index) => (
                    <div key={q.id} className="mb-4">
                        <label
                            className={`block text-lg font-medium mb-2 ${q.required ? "text-red-600" : "text-gray-700"
                                }`}
                        >
                            {index + 1}. {q.question} {q.required && "*"}
                        </label>
                        {q.type === "short-answer" && (
                            <input
                                type="text"
                                className="w-full p-2 border border-gray-300 rounded-lg"
                                placeholder="Your answer"
                            />
                        )}
                        {q.type === "long-answer" && (
                            <textarea
                                className="w-full p-2 border border-gray-300 rounded-lg"
                                placeholder="Your detailed answer"
                            />
                        )}
                        {q.type === "dropdown" && (
                            <select className="w-full p-2 border border-gray-300 rounded-lg">
                                {q.options.map((opt, idx) => (
                                    <option key={idx} value={opt}>
                                        {opt}
                                    </option>
                                ))}
                            </select>
                        )}
                        {q.type === "mcq" && (
                            <div className="space-y-2">
                                {q.options.map((opt, idx) => (
                                    <label key={idx} className="flex items-center space-x-2">
                                        <input type="radio" name={`mcq-${q.id}`} className="radio" />
                                        <span>{opt}</span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
                <button
                    className="w-full p-2 mt-4 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                    onClick={() => setPreview(false)}
                >
                    Back to Builder
                </button>
            </div>
        );
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg w-full">
            <h3 className="text-xl font-bold text-[#2c2c2c] mb-4">Post a New Job</h3>
            <div

            >
                <div>
                    {/* Job Title */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="title">
                            Job Title
                        </label>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        />
                    </div>

                    {/* Job description */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="description">
                            Job Description
                        </label>
                        <textarea
                            id="description"
                            name="description"
                            rows="4"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        ></textarea>
                    </div>

                    {/* Job Category */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="category">
                            Job Category
                        </label>
                        <select
                            id="category"
                            name="category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        >
                            {['Full-Time', 'Part-Time', 'Contract', 'Freelance', 'Internship'].map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Location */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="locationType">
                            Location
                        </label>
                        <select
                            id="locationType"
                            name="locationType"
                            value={locationType}
                            onChange={handleLocationTypeChange}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        >
                            {['In Office', 'Hybrid', 'Remote'].map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                        {showLocationInput && (
                            <input
                                type="text"
                                name="location"
                                value={location}
                                onChange={(e) => setLocation(e.target.value)}
                                placeholder="Enter office location"
                                className="w-full mt-2 p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            />
                        )}
                    </div>

                    {/* Experience Level */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="experienceLevel">
                            Experience Level
                        </label>
                        <select
                            id="experienceLevel"
                            name="experienceLevel"
                            value={experienceLevel}
                            onChange={(e) => setExperienceLevel(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        >
                            {['Entry Level', 'Mid Level', 'Senior Level'].map((level) => (
                                <option key={level} value={level}>
                                    {level}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Salary Range */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="salaryRange">
                            Salary Range (INR)
                        </label>
                        <select
                            id="salaryRange"
                            name="salaryRange"
                            value={salaryRange}
                            onChange={(e) => setSalaryRange(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        >
                            {['<3 LPA', '3-5 LPA', '5-10 LPA', '10-20 LPA', '>20 LPA'].map((range) => (
                                <option key={range} value={range}>
                                    {range}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Application Deadline */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="deadline">
                            Application Deadline
                        </label>
                        <input
                            type="date"
                            id="deadline"
                            name="deadline"
                            value={deadline}
                            onChange={(e) => setDeadline(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        />
                    </div>

                    {/* Departments */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="department">
                            Department
                        </label>
                        <select
                            id="department"
                            name="department"
                            value={department}
                            onChange={(e) => setDepartment(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            required
                        >
                            {['Engineering', 'Marketing', 'Sales', 'HR', 'Finance', 'Design'].map((dept) => (
                                <option key={dept} value={dept}>
                                    {dept}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Responsibilities */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="responsibilities">
                            Responsibilities
                        </label>
                        <textarea
                            id="responsibilities"
                            name="responsibilities"
                            rows="4"
                            value={responsibilities}
                            onChange={(e) => setResponsibilities(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            placeholder="Enter job responsibilities" required
                        ></textarea>
                    </div>

                    {/* Requirements */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="requirements">
                            Requirements
                        </label>
                        <textarea
                            id="requirements"
                            name="requirements"
                            rows="4"
                            value={requirements}
                            onChange={(e) => setRequirements(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            placeholder="Enter job requirements"
                            required
                        ></textarea>
                    </div>

                    {/* Application Link */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="application-link">
                            Application Link
                        </label>
                        <input
                            type="url"
                            id="application-link"
                            name="applicationLink"
                            value={applicationLink}
                            onChange={(e) => setApplicationLink(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            placeholder="Enter application link"
                            required
                        />
                    </div>

                    {/* Contact Email */}
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-[#2c2c2c] mb-1" htmlFor="contact-email">
                            Contact Email for Applications
                        </label>
                        <input
                            type="email"
                            id="contact-email"
                            name="contactEmail"
                            value={contactEmail}
                            onChange={(e) => setContactEmail(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#ee7828]"
                            placeholder="Enter contact email"
                            required
                        />
                    </div>

                    <div className='mb-4'>
                        <div className='block text-sm font-medium text-[#2c2c2c] mb-1'>Upload Company Logo</div>
                        <label htmlFor="cvUpload" className="group relative flex items-center justify-center rounded-md border border-dashed border-gray-300 py-3 px-4 text-center cursor-pointer hover:border-blue-500 transition-colors duration-300">
                            <div className="space-y-1 text-center">
                                <svg
                                    className="mx-auto h-12 w-12 text-gray-400 group-hover:text-blue-500 transition-colors duration-300"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 48 48"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M28 8H12a4 4 0 0-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4h16m-8 0L24 3l4 5m-4 15v7m-8-7h16"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <div className="flex text-sm text-gray-600">
                                    {file ?
                                        <>
                                            <span className="font-medium text-orange-500 group-hover:text-orange-600 transition-colors duration-300">
                                                {file.name}
                                            </span>
                                            <p className="pl-1">File Uploaded</p>
                                        </>
                                        : <>
                                            <span className="font-medium text-blue-500 group-hover:text-blue-600 transition-colors duration-300">
                                                Upload Logo
                                            </span>
                                            <p className="pl-1">or drag and drop</p>
                                        </>
                                    }
                                </div>
                                <p className="text-xs text-gray-500">JPG, JPEG, PNG</p>
                            </div>
                            <input
                                type="file"
                                id="cvUpload"
                                accept=".jpg, .jpeg, .png"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) {
                                        const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                                        if (!allowedTypes.includes(file.type)) {
                                            alert("Invalid file type. Please upload a JPG, JPEG, or PNG file.");
                                            return;
                                        }
                                        console.log("CV uploaded:", file);
                                        setFile(file);
                                    }
                                }}
                            />
                        </label>
                    </div>

                    {/* Toggle Sharing */}
                    <div className="mb-4 flex items-center">
                        <label className="block text-sm font-medium text-[#2c2c2c] mr-4">
                            Allow Sharing
                        </label>
                        <button
                            type="button"
                            onClick={handleToggleSharing}
                            className={`w-16 h-8 flex items-center rounded-full ${allowSharing ? "bg-[#ee7828]" : "bg-gray-300"} p-1 transition-colors`}
                        >
                            <div
                                className={`w-6 h-6 bg-white rounded-full shadow-md transform ${allowSharing ? "translate-x-6" : "translate-x-0"} transition-transform`}
                            ></div>
                        </button>
                    </div>
                </div>



                <div className="w-full max-w-4xl mx-auto p-6 bg-gray-100 shadow-lg rounded-lg">
                    <h2 className="text-2xl font-bold text-primary mb-4">Custom Questionnaire</h2>
                    {questions.map((q, index) => (
                        <div
                            key={q.id}
                            className="mb-4 p-4 bg-white border border-gray-200 rounded-lg shadow-sm"
                        >
                            <label className="block text-sm font-medium text-secondary mb-1">
                                Question {index + 1}
                            </label>
                            <input
                                type="text"
                                value={q.question}
                                onChange={(e) => updateQuestion(q.id, "question", e.target.value)}
                                placeholder="Enter your question"
                                className="w-full p-2 border border-gray-300 rounded-lg mb-2 focus:ring focus:ring-accent focus:outline-none bg-gray-50"
                            />
                            <select
                                value={q.type}
                                onChange={(e) => updateQuestion(q.id, "type", e.target.value)}
                                className="w-full p-2 border border-gray-300 rounded-lg mb-2 focus:ring focus:ring-accent focus:outline-none bg-gray-50"
                            >
                                <option value="short-answer">Short Answer</option>
                                <option value="long-answer">Long Answer</option>
                                <option value="dropdown">Dropdown</option>
                                <option value="mcq">Multiple Choice</option>
                            </select>
                            {["dropdown", "mcq"].includes(q.type) && renderOptionsInput(q.id)}
                            <div className="flex items-center gap-2 mt-2">
                                <label className="text-sm font-medium text-secondary">Required</label>
                                <input
                                    type="checkbox"
                                    checked={q.required}
                                    onChange={(e) => updateQuestion(q.id, "required", e.target.checked)}
                                    className="accent-accent"
                                />
                                <button
                                    type="button"
                                    onClick={() => deleteQuestion(q.id)}
                                    className="text-sm text-error hover:text-red-700"
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    ))}
                    <button
                        type="button"
                        className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-500 mt-4"
                        onClick={addQuestion}
                    >
                        Add Question
                    </button>

                    <button
                        type="button"
                        className="bg-orange-500 text-white px-4 py-2 ml-2 mt-4 rounded-lg hover:bg-orange-500"
                        onClick={() => setPreview(true)}
                    >
                        Preview Form
                    </button>

                    {preview && <FormPreview questions={questions} />}
                </div>



            </div>
            <button
                onClick={() => { handleSubmit() }}
                className="bg-[#2c2c2c] text-white px-4 py-2 rounded mt-4">SUBMIT JOB POST
            </button>

            <button
                onClick={() => { handlePrefill() }}
                className="bg-[#2c2c2c] text-white px-4 py-2 rounded mt-4 ml-4">Test PREFILL </button>
        </div>
    )
}

export default PostJob
